import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AdminApi } from '@/services/api/api.admin';
import { Realmlist } from '@/types/apiServerContract';

@Module({ namespaced: true, dynamic: true, store, name: 'AdminModule' })
class AdminState extends VuexModule {
	@Action({ rawError: true })
    async GetRealms(): Promise<Realmlist[]> {
        const result = await AdminApi.GetRealms();
        return result.realmList;
    }

	@Mutation
	Reset() {}

	@Action({ rawError: true })
	Clear() {
	    this.Reset();
	}

	@Action({ rawError: true })
	async Init() {}
}

const AdminModule = getModule(AdminState);

export { AdminModule };
